export const ERROR = {
  ACCESS_DENIED: {
    type: 'ACCESS_DENIED',
    msg: 'The system is not able to complete the action due to the lack of privileges.',
    url: 'error/ACCESS_DENIED'
  },
  SERVICE_UNAVAILABLE: {
    type: 'SERVICE_UNAVAILABLE',
    msg: 'The service requested by the system is currently unavailable.',
    url: 'error/SERVICE_UNAVAILABLE'
  },
  NOT_FOUND: {
    type: 'NOT_FOUND',
    msg: 'The page you requested is not found.',
    url: 'error/NOT_FOUND'
  },
  UNKNOWN: {
    type: 'UNKNOWN',
    msg: 'Something went wrong and we could not load this page. Please try again in a moment.',
    url: 'error/UNKNOWN'
  }
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/constant/error.constant.ts